import genericErrors from './generic';
import userErrors from './user';

const errorMessages = {
  ...genericErrors,
  ...userErrors,
};

export default errorMessages;
